import {gql} from "@apollo/client";
import {Organization} from "@App/types";

export interface GarageListQuery {
    organization: Organization
}

export const GET_GARAGE_LIST = gql`
    query getGarageList {
        organization(id: 1) {
            garageSiteMap {
                id
                name
                slug
                profileSlug
                street
                city
                postcode
                baseCity {
                    slug
                }
            }
        }
    }
`
